import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const SandIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Sand - gentle waves with dots */}
    <path d="M2 16c2-1 4-1 6 0s4 1 6 0 4-1 6 0" />
    <path d="M2 20c2-1 4-1 6 0s4 1 6 0 4-1 6 0" />
    <circle cx="5" cy="12" r="0.5" fill="currentColor" />
    <circle cx="9" cy="10" r="0.5" fill="currentColor" />
    <circle cx="12" cy="12" r="0.5" fill="currentColor" />
    <circle cx="15" cy="9" r="0.5" fill="currentColor" />
    <circle cx="19" cy="11" r="0.5" fill="currentColor" />
  </svg>
);
